import React, { useMemo, useState, useEffect } from "react";
import TableComponent from "../Common/TableComponent";
import { Link, useLocation } from "react-router-dom";
import FilterComponent from "../Common/FilterComponent";
import TopHeader from "../Common/TopHeader";
import { Container } from "react-bootstrap";
import { GetApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import { CheckPropertyExistOrNot, DisplayToaster, GetTenantId } from "../../core/services/sharedService";

const KioskList = () => {

    const [data, setData] = useState<any>([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [namess, setNamess] = useState();
    const [action, setAction] = useState();
    const [textvisible, setTextvisible] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState<any>();
    const [deleteMsgtimeout, setDeleteMsgtimeout] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const kioskurl = "tenant/kiosk-crud";

    const location = useLocation();

    useEffect(() => {
        GetApiMethod(kioskurl).then((res) => {
            setShowLoader(false);
            setData(res.data.data);
        });
        if (location.state !== null) {
            setNamess(location.state.name);
            setAction(location.state.action);
            setTextvisible(true);
            setTimeout(() => {
                setTextvisible(false);
            }, 10000);
        }
    }, []);

    const copyme = (copytext: any) => {
        let textField = document.createElement('textarea');
        textField.innerText = copytext;
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove();
        DisplayToaster("bg-success", "Kiosk ID copied to clipboard!");
    }

    const columns: any = [
        {
            name: 'Name',
            selector: (row: any) => (CheckPropertyExistOrNot(row, 'name')),
            sortable: true,

        },
        {
            name: 'Location',
            selector: (row: any) => (CheckPropertyExistOrNot(row, 'name', 'location')),
            sortable: true,
        },
        {
            name: 'Kiosk Id',
            selector: (row: any) => (CheckPropertyExistOrNot(row, '_id')),
            sortable: true,
        },
        {
            name: 'Status',
            // selector: (row: any) => ((CheckPropertyExistOrNot(row, 'isActive') === true ? "Active" : (CheckPropertyExistOrNot(row, 'isActive') === false ? "Inactive" : "-"))),
            selector: (row: any) => ('isActive' in row ? (row.isActive ? "Active" : "Inactive") : "-"),
            sortable: true,
        },
        {
            name: 'Linked/Unlinked',
            selector: (row: any) => ('activated' in row ? (row.activated ? "Linked" : "Unlinked") : "-"),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: any) => (
                <div>
                    <span className="cursor-pointer" title="Copy Kiosk ID" onClick={(e) => { copyme(row._id) }}>{<i className="bi bi-clipboard2-plus-fill text-primary mr-1" aria-hidden="true" style={{ fontSize: 24 }}></i>}</span>
                    <Link to={constant.KIOSK_EDIT} state={{ id: row._id, name: row.name, location_name: row?.location?.name, location_id: row.location?._id, status: row.activated, kioskid: row.kioskId, is_active: row.isActive }}><i className="bi bi-pencil-square text-primary m-1" style={{ fontSize: 24 }}></i></Link>
                    {/* <i className="bi bi-trash-fill text-danger m-1 cursor-pointer" id={ row.activated ? "fa-disabled" :""} onClick={(e) => { handleDelete(e, row._id, row.name) }} style={{ fontSize: 24 }}></i> */}
                </div>
            )
        },

    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={(e: any) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const filteredItems = data.filter(
        (item: any) =>
            JSON.stringify([item, (item.isActive ? "Active" : "Inactive"), (item.activated ? "Linked" : "Unlinked")])
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    return (
        <>
            <Container fluid>
                <TopHeader heading="Kiosks" tenant={GetTenantId()} to={constant.KIOSK_CREATE} action="Add" className="bi bi-plus-lg" id="kiosk-create" />
                <div className="text-center text-success mt-3">
                    <h6>{textvisible && (action === "edit" ? namess && "Kiosk " + namess + " details updated successfully" : namess && "Kiosk " + namess + " created successfully")}</h6>
                </div>
                <TableComponent data={data} columns={columns} subHeaderComponent={subHeaderComponent} filteredItems={filteredItems} deleteMsg={deleteMsg} deleteMsgtimeout={deleteMsgtimeout} showLoader={showLoader} />
            </Container>
        </>
    )
}

export default KioskList;